module.exports = __webpack_public_path__ + "static/media/BTCB.f92890de.svg";